type DemoCred = {
  role: string
  email: string
  password: string
}

function parseCreds(raw: string | undefined): DemoCred[] {
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter(
      (c): c is DemoCred =>
        c && typeof c.role === 'string' && typeof c.email === 'string' && typeof c.password === 'string',
    )
  } catch {
    return []
  }
}

export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '',
  demoOrgId: import.meta.env.VITE_DEMO_ORG_ID ?? '',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  },
  demoCreds: parseCreds(import.meta.env.VITE_DEMO_CREDS_JSON),
}
